import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        const mimeErrorMessage = /Expected a JavaScript-or-Wasm module script but the server responded with a MIME type of "text\/html"/;

        if (chunkFailedMessage.test(error.message) || mimeErrorMessage.test(error.message)) {
            console.warn('Detectada falla de carga de módulo (ChunkLoadError). Recargando aplicación...', error);
            window.location.reload();
        } else {
            console.error('Error capturado por GlobalErrorHandler:', error);
        }
    }
}
